import ApiService from './api'

const base = 'controladoria/audiencias'

function buildQuery(values) {
  const query = new URLSearchParams()
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, String(value))
  })
  return query.toString()
}

export function getHearings(filters, { page = 1, pageSize = 25, signal } = {}) {
  const query = buildQuery({ ...filters, pagina: page, tamanhoPagina: pageSize })
  return ApiService.request(`${base}?${query}`, { signal })
}

export function getHearingFilterOptions({ dataInicio, dataFim }, { signal } = {}) {
  return ApiService.request(`${base}/filter-options?${buildQuery({ dataInicio, dataFim })}`, { signal })
}
